/**
 * 认证相关API
 */
import request from '@/utils/request'
import { Sm2Crypto } from '@/utils/sm2'
import { getToken } from '@/utils/auth'

/**
 * 获取SM2公钥
 */
async function getSm2PublicKey() {
  try {
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL || '/api'}/user/pub-config`)
    const result = await response.json()
    if (result.code === 0 && result.data && result.data.sm2PublicKey) {
      return result.data.sm2PublicKey
    }
    throw new Error('获取SM2公钥失败')
  } catch (error) {
    console.error('获取SM2公钥失败:', error)
    throw error
  }
}

/**
 * 登录 - 调用后端真实API
 * @param {Object} params - 登录参数
 * @param {string} params.username - 用户名
 * @param {string} params.password - SM2加密的验证码+密码组合
 * @param {string} params.captchaId - 验证码ID
 * @returns {Promise}
 */
export function login(params) {
  return request({
    url: '/user/login',
    method: 'post',
    data: {
      username: params.username,
      password: params.password,  // SM2加密的验证码+密码组合
      captchaId: params.captchaId, // 验证码ID
      loginType: params.loginType  // 登录类型：username/phone/email
    }
  })
}

/**
 * 获取验证码
 * @param {string} uuid - 验证码ID
 * @returns {Promise}
 */
export function getCaptcha(uuid) {
  return request({
    url: '/user/captcha',
    method: 'get',
    params: {
      uuid: uuid
    },
    responseType: 'blob'
  })
}

/**
 * 注册
 * @param {Object} params
 * @returns {Promise}
 */
export function register(params) {
  return request({
    url: '/user/register',
    method: 'post',
    data: params
  })
}

/**
 * 获取用户信息
 * @returns {Promise}
 */
export function getInfo() {
  return request({
    url: '/user/info',
    method: 'get',
    permissionCritical: true
  })
}

/**
 * 退出登录
 * @returns {Promise}
 */
export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  })
}

/**
 * 修改密码
 * @param {Object} data
 * @returns {Promise}
 */
export function updatePassword(data) {
  return request({
    url: '/user/change-password',
    method: 'put',
    data
  })
}

/**
 * 获取公共配置
 * @returns {Promise}
 */
export function getPubConfig() {
  return request({
    url: '/user/pub-config',
    method: 'get'
  })
}

/**
 * 发送短信验证码
 * @param {Object} data
 * @returns {Promise}
 */
export function sendSmsVerification(data) {
  return request({
    url: '/user/smsVerification',
    method: 'post',
    data
  })
}

/**
 * 找回密码
 * @param {Object} data
 * @returns {Promise}
 */
export function retrievePassword(data) {
  return request({
    url: '/user/retrieve-password',
    method: 'put',
    data
  })
}

/**
 * 获取用户权限列表 - 返回全部权限
 */
export function getPermissions() {
  return Promise.resolve({
    data: {
      code: 200,
      message: '获取权限成功',
      data: ['*']
    }
  })
}
